
export const language = {
    general:{
        exit: 'sair',
        welcome: 'Bem vindo',
        or:"ou",
        and:"e",
        from:"de",
        partner:"parceiro",
        fromAssitive: "da Assistive.",
        signin:"Entrar",
        terms: "termos de uso",
        policy:"política de privacidade",
        resend: "Reenviar",
        needHelp:"Precisa de ajuda?",
        helpCenterText: "Visite nossa central para acessar informações adicionais sobre a instalação e melhores práticas de uso.",
        helpCenter:"Central de ajuda",
        loading: "carregando",
        domain: 'Domínio',
        action: 'Ações',
        active: 'Ativar',
        inactive:'Desativar',
        delete:'excluir',
        pagingMessage:'Mostrando {{param1}} a {{param2}} de {{param3}} linhas',
        badges: {
            active: 'Ativo',
            expired: 'Expirado',
            grace: 'Carência',
            trial: 'Trial'
        },
        clipboard: {
            copied: 'Copiado para a área de transferência',
            error: 'Falha ao copiar'
        }

    },
    footer:{
        rights:"Todos os direitos reservados.",
        terms:"Termos de uso",
        privacy:"Política de privacidade",
        partner:"Seja um parceiro",
        help:"Central de ajuda",
        version:"Versão"
    },
    menu:{
        home: 'Inicio',
        report:'Relatórios',
        perfil:'Perfil',
        hidMenu:'Esconder menu',
        showMenu:'Exibir menu',
        addSite: 'Adicionar novo site',
        peopleUnique: 'Porque as pessoas são únicas...',
        activeSite:'site ativo',
        activeSites:'sites ativos'

    },
    navbar: {
        homePage: 'Página inicial',
        expandMenu: 'Expandir menu lateral',
        noDomain: 'Nenhum domínio cadastrado',
        userDropdown: {
            trialPlan: 'Teste Grátis',
            defaultPlan: 'Plano Atual',
            profile: 'Perfil',
            account: 'Conta',
            logout: 'Sair'
        }
    },
    verticalMenu:{
        sites: "Sites",
        dashboard: "Dashboard",
        installation: "Instalação"
    },
    form:{
        user: 'Usuário',
        password:'Senha',
        login:'Entrar'
    },
    home :{
        greetings:"Bem vindo ao sistema"
    },
    views:{
        login:{
            title: "Olá!",
            subtitle: "Faça o login para gerenciar a sua jornada de acessibilidade digital.",
            email: "Seu email",
            password: "Sua senha",
            forgotPassword: "Esqueceu a senha?",
            remember: "Manter logado",
            newAccount:"iniciar um teste grátis",
            newPlatform:"Novo por aqui?",
            error: "Desculpe, mas algo deu errado. Por favor, verifique seu e-mail e sua senha e tente novamente.",
            loggedSuccessPartA: "Você se conectou com sucesso como um",
            loggedSuccessPartB: "Usuário para Assistive. Agora você pode começar a explorar. Aproveitar!",
            invalidLengthPass: "A senha deve ter no mínimo 8 caracteres.",
            invalidEmail :"Insira um email válido ex: \"email@mail.com\""
        },
        register : {
            title :"Comece agora seus 7 dias de teste grátis!",
            subtitle:"Não precisa cadastrar cartão de crédito",
            email: "Seu email",
            emailPlaceHold: "Email (obrigatório)",
            password: "Senha",
            name:"Qual o seu nome?",
            namePlaceHold: "Nome (obrigatório)",
            partnerPartA: "Quero ser um",
            partnerPartB: "da Assistive.",
            start: "Começar agora",
            agree: "Ao criar minha conta estou de acordo com os",
            haveAccount: "Já te uma conta?"
        },
        reset : {
            title :"Código de autenticação",
            subtitle:"Um email com o código de autenticação foi enviado para:",
            code: "Digite o código de 6 dígitos",
            valid: "Validar",
            codeSpan: "Não recebeu o código?"
        },
        forgot : {
            title :"Esqueceu a senha?",
            subtitle: "Informe seu email de cadastro e enviaremos instruções para você redefinir a sua senha.",
            sendInfo : "Enviar informações",
            backLogin: "Voltar ao login",
            sentTitle: "Instruções enviadas!",
            sentSubtitle: "Acabamos de enviar um email com as instruções para redefinir a sua senha"
        },
        installation: {
            instructions: "Instruções",
            instructionsHelp: `Aqui está o código para a instalação do widget Assistive.
            Agora é so copiar e inserir o código de instalação
            imediatamente antes do fechamento da tag body em seu site.
            Caso queira personalizar nosso widget para ficar com a cara de
            sua marca, selecione a opção "instalação customizada`,
            installationCustom: "Instalação customizada",
            copy:"Copiar código",
            sendInstructions:"Encaminhar instruções",
            retract:"Retrair",
            expand:"Expandir",
            viewCode: "Visualizar código de instalação",
            modalSendEmails: {
                title: 'Envie as instruções por e-mail',
                description: 'Para incluir mais de um endereço de e-mail, basta separá-los por vírgula.',
                emailLabel: 'E-mail',
                emailPlaceholder: 'endereço de e-mail.',
                invalidEmails: 'um ou mais emails são inválidos!',
                sendButton: 'Enviar instruções',
                successToast: 'Código encaminhado para os emails com sucesso'
            },
            wizard: {
                back: 'Voltar',
                next: 'Próximo',
                steps: {
                    method: 'Método',
                    appearance: 'Aparência',
                    whitelabel: 'White Label',
                    desktop: 'Desktop',
                    mobile: 'Mobile',
                    generate: 'Gerar',
                },
                step1: {
                    title: 'Como deseja instalar o widget?',
                    subtitle: 'Escolha entre uma instalação rápida ou configure visualmente antes de gerar o script.',
                    quickTitle: 'Instalação rápida',
                    quickDesc: 'Use o script padrão e instale o widget com poucos cliques.',
                    quickBtn: 'Usar script rápido',
                    quickFeature1: 'Rápido e simples',
                    quickFeature2: 'Ideal para configuração básica',
                    quickFeature3: 'Recomendado para planos simples',
                    configTitle: 'Instalação configurada',
                    configDesc: 'Personalize visualmente o widget, gere um script único e compartilhe.',
                    configBtn: 'Configurar widget',
                    configFeature1: 'Configuração visual completa',
                    configFeature2: 'Desktop, mobile e opções avançadas',
                    configFeature3: 'Gere JSON para reutilizar',
                    tip: 'Dica: você poderá alterar todas as configurações a qualquer momento.',
                },
                step2: {
                    title: 'Aparência do widget',
                    subtitle: 'Configure a forma, o ícone e as cores do widget.',
                    btnShape: 'Forma do botão',
                    btnSize: 'Tamanho do botão',
                    icon: 'Ícone',
                    btnColor: 'Cor do botão',
                    bodyColor: 'Cor do corpo',
                    hPosition: 'Posição horizontal',
                    vPosition: 'Posição vertical',
                    hOffset: 'Deslocamento horizontal',
                    vOffset: 'Deslocamento vertical',
                    features: 'Módulos ativos',
                },
                step3: {
                    title: 'Configurar Mobile',
                    subtitle: 'Ajuste o comportamento do widget em dispositivos móveis.',
                },
                stepDesktop: {
                    title: 'Posicionamento Desktop',
                    subtitle: 'Defina o tamanho e a posição do widget em telas desktop.',
                },
                stepMobile: {
                    title: 'Posicionamento Mobile',
                    subtitle: 'Defina o tamanho e a posição do widget em dispositivos móveis.',
                },
                step4: {
                    title: 'White Label',
                    subtitle: 'Personalize o widget com a identidade visual da sua empresa.',
                    lockTitle: 'Recurso exclusivo Enterprise',
                    lockDesc: 'Faça upgrade para o plano Enterprise e personalize o widget com a identidade visual da sua empresa.',
                    upgrade: 'Fazer upgrade',
                    wlName: 'Nome da empresa',
                    wlNamePlaceholder: 'Ex: Minha Empresa',
                    wlEmail: 'E-mail de contato',
                    wlLogoUri: 'URL do logo',
                    wlLogoLinkUri: 'URL do link do logo',
                    wlStatementUri: 'URL da declaração de acessibilidade',
                },
                step5: {
                    title: 'Pré-visualização',
                    subtitle: 'Veja como o widget ficará no seu site.',
                    desktop: 'Desktop',
                    mobile: 'Mobile',
                    note: 'Pré-visualização aproximada. A renderização final pode variar conforme o site.',
                },
                step6: {
                    title: 'Gerar código de instalação',
                    subtitle: 'Copie o script e cole antes do fechamento da tag </body> no seu site.',
                    tabScript: 'Script inline',
                    tabJson: 'JSON de configuração',
                    copy: 'Copiar código',
                    copied: 'Copiado!',
                    sendEmail: 'Enviar por e-mail',
                },
                shapes: { circle: 'Círculo', square: 'Quadrado', rounded: 'Arredondado' },
                sizes: { small: 'Pequeno', medium: 'Médio', large: 'Grande' },
                icons: { default: 'Padrão', config: 'Config', gear: 'Engrenagem', font: 'Fonte', wheelchair: 'Cadeira', old: 'Pessoa' },
                positions: { left: 'Esquerda', right: 'Direita', top: 'Topo', center: 'Centro', bottom: 'Rodapé' },
                features: {
                    displayActive: 'Acessibilidade visual',
                    speechActive: 'Leitura de tela',
                    signsActive: 'LIBRAS',
                },
            }
        },
        sites: {
            mySites: 'Meus sites',
            noSite: 'Você ainda não cadastrou nenhum site.',
            addNow:'Adicionar agora',
            plan: 'Plano',
            domain: 'Domínios',
            all: 'todos',
            inactive: 'inativos',
            actives: 'ativos',
            addSite: 'Adicionar Site',
            updatedSite: 'Atualizando site',
            code:'Visualizar código de instalação',
            search: 'Buscar',
            planStatus: {
                trial: {
                    daysRemaining: 'Faltam {{days}} dias para encerrar seu teste grátis',
                    hoursRemaining: 'Faltam {{hours}} horas para encerrar seu teste grátis',
                    expired: 'Seu período de testes encerrou, ative a licença para continuar usando'
                },
                active: {
                    renewal: 'Renovação automática em {{date}}.',
                    renewalDays: 'Renovação automática em {{days}} dias.'
                },
                expired: 'Seu plano expirou em {{date}}',
                grace: 'Seu plano está em período de carência e será desativado em {{date}}'
            },
            actions: {
                activateLicense: 'Ativar licença',
                promotionalCode: 'Código promocional',
                updatePlan: 'Atualizar plano'
            },
            planDescription: {
                free: 'Para empresas com até 10 funcionarios, mediante a análise.',
                essential: 'Para empresesas com sites com baixo volume de acessos. Apenas 1(um) Domínio.',
                advanced: 'Plano até 10.000 page views. Para empresas volume de acesso intermediário e mais de um domínio. Até 2(dois) Domínios.',
                enterprise: 'Plano com page views ilimitadas. Para empresas com alto volume de acessos e que necessitam de serviços gerenciados e personalizados.'
            },
            trialLabel: 'TRIAL',
            modalCode: {
                description: 'Copie o código abaixo e implante em seu domínio',
                copyButton: 'Copiar Código'
            }
        },
        dashboard: {
            header: {
                title: 'Painel de acompanhamento'
            },
            periods: {
                lastMonth: 'Último mês',
                threeMonths: '3 meses',
                twelveMonths: '12 meses'
            },
            months: {
                jan: 'Jan',
                fev: 'Fev',
                mar: 'Mar',
                abr: 'Abr',
                mai: 'Mai',
                jun: 'Jun',
                jul: 'Jul',
                ago: 'Ago',
                set: 'Set',
                out: 'Out',
                nov: 'Nov',
                dez: 'Dez'
            },
            globalAlert: {
                title: 'Sem dados de uso ainda:',
                description: 'Estamos a coletar informações de uso para atualizar o painel.'
            },
            topMetrics: {
                pageViews: {
                    title: 'Page Views',
                    subtitle: 'Total de visualizações de páginas'
                },
                pluginOpens: {
                    title: 'Aberturas do Plugin',
                    subtitle: 'Total de vezes que o plugin foi aberto'
                },
                totalEvents: {
                    title: 'Total de Eventos',
                    subtitle: 'Interações totais com o plugin'
                },
                emptyDash: '--'
            },
            usageOverTime: {
                title: 'Uso ao longo do tempo',
                seriesName: 'Eventos',
                error: {
                    message: 'Não foi possível carregar os dados.',
                    retry: 'Tentar Novamente'
                },
                empty: {
                    title: 'Comece a usar seu plugin para ver o desempenho',
                    subtitle: 'Aqui, você vai entender a utilização do plugin ao longo dos meses.'
                },
                noDomain: {
                    title: 'Cadastre um domínio e comece a usar para ver o desempenho',
                    subtitle: 'Aqui você vai entender a utilização do plugin ao longo do tempo'
                }
            },
            insights: {
                title: 'Tendências e Insights',
                error: {
                    message: 'Não foi possível carregar os dados.',
                    retry: 'Tentar Novamente'
                },
                empty: {
                    title: 'Aguarde a coleta de dados',
                    subtitle: 'Estamos a coletar informações para exibir as tendências e Insights.'
                },
                noDomain: {
                    title: 'Cadastre um domínio e comece a usar para ver o desempenho',
                    subtitle: 'Aqui você vai ver as tendências e insights sobre a utilização do plugin'
                },
                dynamic: {
                    topFeature: {
                        prefix: 'A ferramenta ',
                        middle: ' foi a mais utilizada, acumulando ',
                        suffix: ' eventos no período.'
                    },
                    peakUsage: {
                        dayPrefix: 'O dia ',
                        monthPrefix: 'O mês de ',
                        middle: ' registrou o maior volume de uso, alcançando ',
                        suffix: ' eventos.'
                    },
                    topProfile: {
                        prefix: 'O perfil de navegação ',
                        middle: ' liderou em número de ativações, sendo acionado ',
                        suffix: ' vezes.'
                    }
                }
            },
            resourcesRanking: {
                title: 'Recursos mais utilizados',
                error: {
                    message: 'Falha ao carregar informações',
                    retry: 'Tentar Novamente'
                },
                empty: {
                    title: 'Sem dados de uso ainda',
                    subtitle: 'Estamos a coletar informações para exibir estas informações.'
                },
                noDomain: {
                    title: 'Cadastre um domínio e comece a usar para ver o desempenho',
                    subtitle: 'Aqui você vai ver quais recursos do plugin são mais utilizados pelos seus usuários'
                },
                footer: 'Resultado mensal de todos os recursos utilizados.',
                events: 'eventos'
            },
            profiles: {
                title: 'Distribuição de Perfis utilizados',
                error: {
                    message: 'Não foi possível carregar os dados.',
                    retry: 'Tentar Novamente'
                },
                empty: {
                    title: 'Sem dados de uso ainda',
                    subtitle: 'Estamos a coletar informações para exibir estas informações.'
                },
                noDomain: {
                    title: 'Cadastre um domínio e comece a usar para ver o desempenho',
                    subtitle: 'Aqui você vai ver como os perfis de acessibilidade estão sendo utilizados'
                },
                footerLinkText: 'Entenda como funciona os perfis de acessibilidade',
                iconAlt: 'Ícone',
                arrowAlt: 'Seta',
                tooltip: {
                    eventsLabel: 'eventos'
                }
            },
            detailedUsage: {
                title: 'Uso detalhado dos recursos',
                filter: {
                    all: 'Todos',
                    categories: {
                        content: 'Conteúdo',
                        navigation: 'Navegação',
                        colorAndScreen: 'Cor e Tela'
                    }
                },
                searchPlaceholder: 'Buscar',
                searchAlt: 'Pesquisar',
                subtitleAll: 'Todos',
                subtitleFiltered: 'Resultados Filtrados',
                error: {
                    message: 'Não foi possível carregar os dados.',
                    retry: 'Tentar Novamente'
                },
                empty: {
                    noData: 'Sem dados de uso disponíveis no momento.',
                    noResults: 'Nenhum recurso encontrado para esta busca.'
                },
                events: 'eventos'
            }
        },
        accountSettings: {
            title: 'Configurações da conta',
            tabs: {
                account: 'Conta',
                security: 'Segurança',
                billing: 'Cobrança & Plano'
            },
            accountTab: {
                sectionTitle: 'Tipo de conta',
                saveButton: 'Salvar alterações',
                cancelButton: 'Cancelar'
            },
            deleteAccount: {
                title: 'Excluir conta',
                warningStrong: 'Você tem certeza que deseja excluir essa conta?',
                warningText: 'Depois de excluir sua conta, não há como voltar atrás. Por favor, tenha certeza.',
                confirmLabel: 'Confirmar exclusão da minha conta',
                button: 'Excluir conta'
            },
            formBilling: {
                taxpayerTypeCorporate: 'Pessoa Jurídica',
                taxpayerTypePersonal: 'Pessoa Física',
                companyDataTitle: 'Dados da empresa',
                personalDataTitle: 'Dados pessoais',
                cpfLabel: 'Documento de identificação (CPF)',
                cpfInvalid: 'CPF inválido',
                cnpjLabel: 'Documento de identificação (CNPJ)',
                cnpjInvalid: 'CNPJ inválido',
                simplesLabel: 'Optante pelo Simples Nacional?',
                simplesYes: 'Sim',
                simplesNo: 'Não',
                corporateName: 'Razão social',
                fullName: 'Nome completo',
                fantasyName: 'Nome fantasia',
                required: 'Campo obrigatório',
                financialContact: 'Contato Financeiro',
                responsibleName: 'Nome do responsável',
                responsibleNamePlaceholder: 'Nome responsável',
                financialEmail: 'Email (que receberá a fatura)',
                emailInvalid: 'Email informado é inválido',
                phone: 'Telefone',
                phoneInvalid: 'Telefone informado é inválido!',
                address: 'Endereço',
                zipCode: 'CEP',
                zipCodeInvalid: 'CEP inválido',
                number: 'Número',
                complement: 'Complemento',
                neighborhood: 'Bairro',
                state: 'Estado',
                city: 'Cidade',
                toast: {
                    loading: 'Salvando requisição',
                    success: 'Salvo.',
                    error: 'Erro ao salvar requisição, tente novamente mais tarde'
                }
            },
            limitePlan: {
                title: 'Limites do plano',
                availableDomains: 'Domínios disponíveis',
                pageviewsPerMonth: 'Pageviews por mês'
            },
            invoiceTable: {
                title: 'Histórico de faturas',
                headers: {
                    date: 'Data',
                    invoiceNumber: 'Número de cobrança',
                    plan: 'Plano',
                    amount: 'Valor',
                    status: 'Status'
                },
                statuses: {
                    open: 'Em aberto',
                    paid: 'Paga'
                },
                actions: {
                    download: 'Download da fatura',
                    view: 'Visualizar fatura'
                },
                empty: 'Você não possui nenhuma cobrança.'
            }
        },
        perfil: {
            title: 'Perfil',
            userInfo: {
                title: 'Informações do usuário',
                subtitle: 'Atualize as informações do seu usuário',
                fullName: 'Nome completo',
                nickname: 'Apelido',
                email: 'Endereço de e-mail',
                phone: 'Telefone',
                required: 'Esse é um campo obrigatório',
                saveButton: 'Salvar alterações',
                changePasswordButton: 'Alterar senha',
                toast: {
                    loading: 'Atualizando informação',
                    success: 'Informações Atualizadas',
                    error: 'Erro ao Atualizar informações'
                }
            },
            changePassword: {
                title: 'Alterar senha',
                subtitle: 'A senha deve conter pelo menos 8 caracteres.',
                oldPassword: 'Senha antiga',
                newPassword: 'Nova senha',
                required: 'Esse é um campo obrigatório',
                minLength: 'A senha deve ter no mínimo 8 caracteres.',
                button: 'Alterar senha',
                toast: {
                    error: 'Senha incorreta',
                    success: 'Alterada com sucesso'
                }
            }
        },
        features: {
            tags: {
                conteudo: 'Conteúdo',
                navegacao: 'Navegação',
                corTela: 'Cor e Tela',
                perfil: 'Perfil'
            },
            init: 'Page views',
            toolbarT: 'Abertura de Plugin',
            textsize1T: 'Texto Maior 125%',
            textsize2T: 'Texto Maior 140%',
            textsize3T: 'Texto Maior 170%',
            textsize4T: 'Texto Maior 200%',
            align_centerT: 'Alinhamento Centralizado',
            align_justifyT: 'Alinhamento Justificado',
            align_leftT: 'Alinhamento à Esquerda',
            align_rightT: 'Alinhamento à Direita',
            font_dyslexicT: 'Fonte para Dislexia',
            font_sansserifT: 'Fonte sem Serifa (Leitura)',
            font_serifT: 'Fonte com Serifa',
            linespacing1T: 'Espaçamento de Linhas 120%',
            linespacing2T: 'Espaçamento de Linhas 140%',
            linespacing3T: 'Espaçamento de Linhas 160%',
            charspacing1T: 'Espaçamento de letras 105%',
            charspacing2T: 'Espaçamento de letras 110%',
            charspacing3T: 'Espaçamento de letras 120%',
            imageT: 'Sem imagens',
            spkOpen: 'Leitor de Site',
            tooltipsT: 'Mostrar Descrições',
            imgdescT: 'Descrições de Imagens',
            soundT: 'Sem Som',
            vlibrasT: 'Libras',
            smartcontrast_defaultT: 'Contraste de Texto Mínimo',
            smartcontrast_highT: 'Contraste de Texto Médio',
            smartcontrast_maxT: 'Contraste de Texto Máximo',
            contrast1T: 'Contraste da Página 125%',
            contrast2T: 'Contraste da Página 150%',
            contrast3T: 'Contraste da Página 175%',
            contrast4T: 'Contraste da Página 200%',
            contrast5T: 'Contraste da Página 300%',
            saturation_dessaturateT: 'Cores Desbotadas',
            saturation_highT: 'Cores Intensas',
            saturation_lowT: 'Tons de Cinza',
            colors_invertT: 'Inverter Cores',
            colors_shift60T: 'Cores (Rotaciona 60°)',
            colors_shift120T: 'Cores (Rotaciona 120°)',
            colors_shift240T: 'Cores (Rotaciona 240°)',
            magnifyingT: 'Lupa',
            structclick: 'Estrutura da Pagina',
            cursor_blackT: 'Cursor Preto',
            cursor_blueT: 'Cursor Azul',
            cursor_redT: 'Cursor Vermelho',
            cursor_whiteT: 'Cursor Branco',
            guideT: 'Guia de Leitura',
            rulerT: 'Regua de Leitura',
            animationT: 'Para Animações',
            highlight_allT: 'Destacar Todos Elementos',
            highlight_btnT: 'Destacar Botões',
            highlight_linkT: 'Destacar Links',
            highlight_titleT: 'Destacar Títulos',
            focusT: 'Destaque Foco do Teclado',
            prof_p60_T: 'Navegação 60+',
            prof_seizures_T: 'Navegação Epilepsia',
            prof_vision_T: 'Navegação Baixa Visão',
            prof_adhd_T: 'Navegação TDAH',
            prof_dyslexic_T: 'Navegação Dislexia',
            prof_cognitive_T: 'Navegação auxílio cognitivo',
            prof_motor_T: 'Navegação por teclado',
            prof_blind_T: 'Navegação por leitores de tela (Cego)'
        }
    }
}
